import React from "react";
import SubsectionHeader from "@/components/shared/SubsectionHeader";
import Footer from "@/components/Footer";

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* 顶部 Hero */}
        <SubsectionHeader
          title="分贝视界（深圳）科技有限公司"
          description="开启独一无二的兴趣探索之旅"
          icon="Building2"
          variant="hero"
        />

        {/* 公司简介 */}
        <section className="mx-auto max-w-3xl py-6 sm:py-8">
          <h2 className="mb-4 text-center text-xl sm:text-2xl font-semibold text-foreground">
            公司简介
          </h2>
          <div className="prose prose-sm sm:prose-base dark:prose-invert leading-relaxed mx-auto">
            <p>
              成立于 2021
              年的分贝视界（深圳）科技有限公司，是一家专注于音视频技术领域的创新型企业。我们秉持着
              "通过音视频，开启独一无二的兴趣探索之旅"
              的理念，致力于利用最前沿的技术为用户提供高度定制化的兴趣爱好体验。
            </p>
            <p>
              在这个快速发展的数字时代，我们相信每个人都有独特的兴趣和激情等待被发现或深化。分贝视界凭借其专业的技术研发团队和对市场的深刻理解，开发出一系列旨在满足个人化需求的产品和服务。无论是激发新兴趣还是深入已有爱好，我们的解决方案都能让用户以一种全新的、互动的方式享受他们的兴趣世界。
            </p>
            <p>
              我们不仅关注技术的进步，更注重用户体验的提升。通过不断的研究和创新，分贝视界努力打破传统界限，将先进技术的力量融入到每一个细节中，确保每一位用户都能享受到量身定制的服务体验。加入我们，一起探索无限可能，让每一天都充满新的发现。
            </p>
          </div>
        </section>

        {/* 我们的优势 */}
        <section className="mx-auto max-w-3xl py-6 sm:py-8">
          <h2 className="mb-4 text-center text-xl sm:text-2xl font-semibold text-foreground">
            我们的优势
          </h2>
          <div className="grid gap-4 sm:gap-6 sm:grid-cols-2">
            {[
              {
                title: "先进技术",
                desc: "我们整合最先进的音视频技术，为用户提供独特且丰富的兴趣探索体验。",
                icon: (
                  <svg
                    className="h-5 w-5 text-foreground"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    />
                  </svg>
                ),
              },
              {
                title: "个性化服务",
                desc: "通过高度定制化的服务，我们根据每位用户的偏好和需求量身打造专属的兴趣爱好旅程。",
                icon: (
                  <svg
                    className="h-5 w-5 text-foreground"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                    />
                  </svg>
                ),
              },
              {
                title: "创新文化",
                desc: "拥有创新驱动的研发文化，不断探索新技术、新方法以提升产品和服务质量。",
                icon: (
                  <svg
                    className="h-5 w-5 text-foreground"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                ),
              },
              {
                title: "全方位支持",
                desc: "提供从兴趣激发到技能提升的全方位支持平台，促进用户间的交流与共同进步。",
                icon: (
                  <svg
                    className="h-5 w-5 text-foreground"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9"
                    />
                  </svg>
                ),
              },
            ].map((item) => (
              <div
                key={item.title}
                className="flex gap-x-4 rounded-2xl border border-border bg-card p-5 shadow-sm"
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-muted shrink-0">
                  {item.icon}
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground mb-1">
                    {item.title}
                  </h3>
                  <p className="text-xs text-muted-foreground leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* 联系方式 */}
        <section className="mx-auto max-w-3xl py-6 sm:py-8">
          <h2 className="mb-4 text-center text-xl sm:text-2xl font-semibold text-foreground">
            联系我们
          </h2>
          <div className="space-y-4 rounded-2xl border border-border bg-card p-5 sm:p-6 shadow-sm">
            <div className="flex items-center gap-x-4">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-muted">
                <svg
                  className="h-5 w-5 text-foreground"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <p className="text-sm text-muted-foreground">contact@tunzo.cn</p>
            </div>
            <div className="flex items-center gap-x-4">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-muted">
                <svg
                  className="h-5 w-5 text-foreground"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </div>
              <p className="text-sm text-muted-foreground">+86 15302693997</p>
            </div>
            <div className="flex items-center gap-x-4">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-muted">
                <svg
                  className="h-5 w-5 text-foreground"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </div>
              <p className="text-sm text-muted-foreground">
                深圳市南山区粤海街道高新区社区高新南七道206号高新工业村R2-2楼A区2143
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
